import { useCallback } from 'react';
import { VoiceCall } from '../../lib/voice-call';
import { ENDED_VOICE_STATE } from './useVoiceState';
import { useVoiceLifecycle } from './useVoiceLifecycle';

const FAILURE_CODES = { NotAllowedError: 'permission', NotFoundError: 'microphone', NotReadableError: 'microphone' };

export function useVoiceConnection({ call, language, demo, scenario, muted, update, resetState,
  receive, generating, save, resetTranscript }) {
  const reset = useCallback(() => {
    call.current?.close(); call.current = null; generating.current = false;
    resetTranscript(); resetState();
  }, [call, generating, resetTranscript, resetState]);
  const start = useCallback(async () => {
    if (call.current && !call.current.closed) return;
    reset();
    const owner = new VoiceCall(patch => { if (call.current === owner) update(patch); }, receive);
    call.current = owner;
    try { await owner.start(language, { is_demo: demo, scenario }); }
    catch (error) { if (!owner.closed) owner.fail(FAILURE_CODES[error.name] || error.message); }
  }, [call, demo, language, receive, reset, scenario, update]);
  const end = useCallback(() => {
    call.current?.close(); update(ENDED_VOICE_STATE); save();
  }, [call, save, update]);
  const mute = useCallback(() => { call.current?.mute(!muted); update({ muted: !muted }); }, [call, muted, update]);
  const interrupt = useCallback(() => {
    call.current?.interrupt(generating.current); update({ speaking: false, thinking: false });
  }, [call, generating, update]);
  const play = useCallback(() => call.current?.play(), [call]);
  useVoiceLifecycle(call, end, update);
  return { start, end, mute, interrupt, play, reset };
}